import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Unlock.svg?component
var Unlock_exports = /* @__PURE__ */ __exportAll({
	default: () => Unlock_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1), createElementVNode("path", { d: "M5.778 10h12.444c.982 0 1.778.895 1.778 2v8c0 1.105-.796 2-1.778 2H5.778C4.796 22 4 21.105 4 20v-8c0-1.105.796-2 1.778-2M17 10V7a5 5 0 0 0-9.33-2.5" }, null, -1)])]);
}
var Unlock_default = { render: render$1 };
//#endregion
export { Unlock_exports, Unlock_default as default, render$1 as render };

//# sourceMappingURL=Unlock.svg.virtual.js.map